import styles from './style.postcss';
import React, { PureComponent } from 'react';
import is from 'is_js';
import { DropdownBox } from 'omni-common-ui';
import { Map } from 'immutable';
import classnames from 'classnames';
import PropTypes from 'prop-types';

class OptionsCell extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { isDropdownOpen: false };
    this._prepareOptionsToRender(props);
  }

  componentWillUpdate(nextProps) {
    this._prepareOptionsToRender(nextProps);
  }

  _toggleDropdown(evt) {
    if (evt) {
      evt.preventDefault();
      evt.stopPropagation();
    }
    this.setState((state) => ({ isDropdownOpen: ! state.isDropdownOpen }));
  }

  _prepareOptionsToRender(props) {
    const { cellOptions, args } = props;
    this._options = is.function(cellOptions) && new Map(cellOptions(...args));
    this._canOpen = this._options.size > 0;
    // just for Tutorial Book of HF 3.0
    this._isInVarietyMode = this._options && this._options.size > 4;
  }

  _renderDropdown() {
    const className = classnames(styles.OptionsCell_dropdown, {
      [styles.OptionsCell_dropdown_varietyMode]: this._isInVarietyMode }
    );
    return <DropdownBox className={className}
        open={this.state.isDropdownOpen === true && this._canOpen}
        smartPosition>.
      {this._isInVarietyMode &&
        <DropdownBox.Item className={styles.OptionsCell_dropdown_optionFirstHeader}>
          {this.props.firstOptionHeader}
        </DropdownBox.Item>}
      {this._isInVarietyMode &&
        <DropdownBox.Item className={styles.OptionsCell_dropdown_optionSecondHeader}>
          {this.props.secondOptionHeader}
        </DropdownBox.Item>}
      {
        this._options && this._options.map &&
        // eslint-disable-next-line react/no-array-index-key
        this._options.map((config, key) => <DropdownBox.Item key={key}
            className={this._isInVarietyMode && styles.OptionsCell_dropdown_item}
            onClick={(evt) => {
              config.onClick(evt);
              // close the dropdown. this is the expected UX in most situations (I think)
              this._toggleDropdown();
            }}>
          {config.label}
        </DropdownBox.Item>)
      }
    </DropdownBox>;
  }

  render() {
    const { args, buildCell } = this.props;
    const classes = classnames(styles.OptionsCell, {
      [styles.__canOpen]: this._canOpen,
      [styles.__isOpen]: this.state.isDropdownOpen === true,
    });

    return <DropdownBox.Container className={classes}
        onClickOutside={() => this.setState({ isDropdownOpen: false })}>
      <div className={styles.OptionsCell_wrap}
          onClick={this._canOpen && ((e) => this._toggleDropdown(e))}>
        {buildCell(...args)}
      </div>
      {this._renderDropdown()}
    </DropdownBox.Container>;
  }
}

OptionsCell.propTypes = {
  firstOptionHeader: PropTypes.string,
  secondOptionHeader: PropTypes.string,
  cellOptions: PropTypes.func,
  buildCell: PropTypes.func,
  args: PropTypes.oneOfType([PropTypes.shape(), PropTypes.array]),
};

export default OptionsCell;



// WEBPACK FOOTER //
// ./components/CourseViewTable/OptionsCell/index.jsx